const calculatePackagePricePPPW = (state, includingDiscount) => {
  // this is the lead tenant calculation
  if (
    state.packagePrice.fullPriceAmount > 0 &&
    state.packagePrice.discountedPriceAmount > 0
  ) {
    return includingDiscount
      ? state.packagePrice.discountedPriceAmount
      : state.packagePrice.fullPriceAmount;
  } else if (state.products.length && state.accountInformation.guid === "") {
    const getOptionPrice = (option, includingDiscount) => {
      let value;

      if (!includingDiscount && option.price.old) {
        value = option.price.old;
      } else {
        value = option.price.current;
      }

      return value;
    };

    return state.products
      .map(({ options, selected }) => {
        const option = options.find((opt) => opt.code === selected);
        return getOptionPrice(option, includingDiscount);
      })
      .reduce((total, price) => total + price, 0);
  } else {
    // this is the joining housemate calculation
    if (!includingDiscount && !!state.accountInformation.nonDiscountedPppw) {
      return state.accountInformation.nonDiscountedPppw;
    }

    // Discount will already be applied here if one was used.
    return state.accountInformation.pppw;
  }
};

export { calculatePackagePricePPPW };
